import { combineReducers } from 'redux'
import { dataUser } from './user'
const Reducers = combineReducers({
  dataUser
})

export default Reducers
